import RequestService from '@/service'
import type { IApiTeam } from './type.ts'

export default class ApiTeam {
  // 团队 列表 （获取当前用户团队列表）
  static list() {
    return RequestService.get({
      url: '/chain/group/getList'
    })
  }

  // 团队 新增
  static add(data?: IApiTeam.TAddOrEdit) {
    return RequestService.post({
      url: '/chain/group/create',
      data
    })
  }

  // 团队 编辑
  static edit(data?: IApiTeam.TAddOrEdit) {
    return RequestService.put({
      url: '/chain/group/update',
      data
    })
  }

  // 团队 解散
  static del(params?: IApiTeam.TDel) {
    return RequestService.delete({
      url: '/chain/group/disband',
      params
    })
  }

  // 团队 解散
  static role(params?: IApiTeam.TRole) {
    return RequestService.get({
      url: '/chain/group/get',
      params
    })
  }

  // 团队 统计
  static statistics(params?: IApiTeam.TStatistics) {
    return RequestService.get({
      url: '/chain/group/getStats',
      params
    })
  }

  // 团队 邀请（邀请加入团队（生成验证码））
  static memberInviteCode(params?: IApiTeam.TMemberInviteCode) {
    return RequestService.get({
      url: '/chain/group/invite',
      params
    })
  }

  // 团队 邀请（根据 验证码 获取邀请信息）
  static memberInviteInfo(params?: IApiTeam.TMemberInviteInfo) {
    return RequestService.get({
      url: '/chain/group/get-invite',
      params
    })
  }

  // 团队 列表（分页成员）
  static memberList(params?: IApiTeam.TMemberList) {
    return RequestService.get({
      url: '/chain/group/group-page',
      params
    })
  }

  // 团队 列表（所有成员）
  static memberListAll(params?: IApiTeam.TMemberListAll) {
    return RequestService.get({
      url: '/chain/group/group-all',
      params
    })
  }

  // 团队 加入（把别人 加入团队）
  static memberJoin(params?: IApiTeam.TMemberJoin) {
    return RequestService.put({
      url: '/chain/group/add',
      params
    })
  }

  // 团队 移除（把别人 移除团队）
  static memberDel(params?: IApiTeam.TMemberDel) {
    return RequestService.put({
      url: '/chain/group/exit',
      params
    })
  }

  // 团队（ 角色变更 ）
  static memberChangeRole(params?: IApiTeam.TMemberChangeRole) {
    return RequestService.put({
      url: '/chain/group/change',
      params
    })
  }

  // 设置 团队 系统 logo + name
  static detailSystemInfo(params?: IApiTeam.TSystemInfo) {
    return RequestService.get({
      url: '/chain/group/get-other',
      params
    })
  }

  // 设置 团队 系统 logo + name
  static addOrEditSystemInfo(data?: IApiTeam.TSystemInfoAddOrEdit) {
    return RequestService.put({
      url: '/chain/group/update-other',
      data
    })
  }

  // 更新蒲公英账号 cookie
  static updateCookie(cookie: string) {
    return RequestService.put({
      url: '/chain/web-magic/put-cookie',
      params: { cookie }
    })
  }

  // 检查是否需要显示更新蒲公英账号
  static checkWebMagic() {
    return RequestService.get({
      url: '/chain/web-magic/check'
    })
  }
}
